// src/components/ui/SecretDisplayModal.tsx

import { Modal, Button, Input } from 'antd';

/**
 * 一次性密钥展示模态框
 * 用于安全展示 App Secret 等敏感信息
 */
export const SecretDisplayModal = ({
  open,
  iosSecret,
  androidSecret,
  onClose,
}: {
  open: boolean;
  iosSecret: string;
  androidSecret: string;
  onClose: () => void;
}) => {
  /**
   * 复制文本到剪贴板
   */
  const copyToClipboard = (text: string): void => {
    navigator.clipboard.writeText(text).catch(() => {
      // 降级方案（如不支持 Clipboard API）
      const textArea = document.createElement('textarea');
      textArea.value = text;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    });
  };

  return (
    <Modal
      title="请立即保存密钥！"
      open={open}
      onCancel={onClose}
      footer={[
        <Button key="close" onClick={onClose}>
          我已保存
        </Button>,
      ]}
      width={600}
      className="max-w-2xl"
    >
      <div className="space-y-4">
        <div>
          <h3 className="font-medium text-gray-700 mb-2">iOS App Secret</h3>
          <div className="flex gap-2">
            <Input 
              value={iosSecret} 
              readOnly 
              className="font-mono text-sm"
            />
            <Button 
              onClick={() => copyToClipboard(iosSecret)}
              size="small"
            >
              复制
            </Button>
          </div>
          <p className="text-xs text-gray-500 mt-1">
            此密钥仅显示一次，请立即保存！刷新页面后将无法再次查看。
          </p>
        </div>

        <div>
          <h3 className="font-medium text-gray-700 mb-2">Android App Secret</h3>
          <div className="flex gap-2">
            <Input 
              value={androidSecret} 
              readOnly 
              className="font-mono text-sm"
            />
            <Button 
              onClick={() => copyToClipboard(androidSecret)}
              size="small"
            >
              复制
            </Button>
          </div>
          <p className="text-xs text-gray-500 mt-1">
            此密钥仅显示一次，请立即保存！刷新页面后将无法再次查看。
          </p>
        </div>

        <div className="bg-yellow-50 border-l-4 border-yellow-400 p-3 mt-4">
          <p className="text-yellow-700 text-sm">
            <strong>安全提示：</strong>
            请勿将密钥提交到代码仓库或分享给他人。
          </p>
        </div>
      </div>
    </Modal>
  );
};